<div class="body">

    <mat-toolbar class="ams-toolbar">

        <button mat-icon-button>
            <mat-icon>widgets</mat-icon>
        </button>
        <span>Sicht wählen</span>

        <span class="spacer"></span>

        <button mat-icon-button (click)="close()" color="warn">
            <mat-icon>close</mat-icon>
        </button>

    </mat-toolbar>

    <div class="content">

        <div class="option" *ngFor="let option of options" (click)="selectOption(option)">
            <mat-checkbox class="checkbox" [checked]="option.value == currentValue"></mat-checkbox>
            <div>
                <div class="headline">
                    {{option.title}}
                </div>
                <div class="sub-title">
                    {{option.desc}}
                </div>
            </div>
        </div>
        
    </div>
</div>